import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useCreateDoc2USessionMutation as useCreateDoc2USessionMutationType } from "@/modules/patients/detail/progress-note/doc2u/services/__generated__/useCreateDoc2USessionMutation.graphql"

const mutation = graphql`
  mutation useCreateDoc2USessionMutation($input: CreateDoc2USessionInput!) {
    createDoc2USession(input: $input) {
      roomDoc2UOutput {
        appEndpoint
        practitionerTokenKey
      }
    }
  }
`

const useCreateDoc2USessionMutation = () => {
  const [commit, isFlight] = useMutation<useCreateDoc2USessionMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useCreateDoc2USessionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useCreateDoc2USessionMutation }
